import { render, staticRenderFns } from "./GerarTabela.vue?vue&type=template&id=6074a363&scoped=true"
import script from "./GerarTabela.vue?vue&type=script&lang=js"
export * from "./GerarTabela.vue?vue&type=script&lang=js"
import style0 from "./GerarTabela.vue?vue&type=style&index=0&id=6074a363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6074a363",
  null
  
)

export default component.exports